<nav class="navbar navbar-expand-lg navbar-dark" [style]="'background-color: ' + navBarColor + ' !important;'">
  <a class="navbar-brand" routerLink="gitih/home"><img src="assets/logos/logo.png" class="pr-3">{{titol}}</a>
  <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarSupportedContent"
    aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
    <span class="navbar-toggler-icon"></span>
  </button>

  <div class="collapse navbar-collapse" id="navbarSupportedContent">
    <ul class="navbar-nav mr-auto">
      <li class="nav-item dropdown" *ngIf="auth.estaAutenticat() && opcionsPerfil()" routerLinkActive="active">
        <a class="nav-link dropdown-toggle" href="#" id="navbarDropdown" role="button" data-toggle="dropdown"
          aria-haspopup="true" aria-expanded="false">
          Gestió
        </a>
        <div class="dropdown-menu" aria-labelledby="navbarDropdown">
          <a class="dropdown-item" routerLink="gestio/activitat" *ngIf="auth.perfilAutoritzat('activitat')">Activitat</a>
          <div class="dropdown-divider" *ngIf="auth.perfilAutoritzat('activitat')"></div>
          <a class="dropdown-item" routerLink="gitih/pacients">Pacients</a>
          <a class="dropdown-item" routerLink="gitih/pacients/historic" *ngIf="auth.perfilAutoritzat('historic')">Històric</a>
          <div class="dropdown-divider" *ngIf="(logServidorBd || logICAMBd) && (auth.perfilAutoritzat('logs') || auth.perfilAutoritzat('logs-icam'))"></div>
          <a class="dropdown-item" *ngIf="logServidorBd && auth.perfilAutoritzat('logs')" routerLink="gestio/logs">Logs</a>
          <a class="dropdown-item" *ngIf="logICAMBd && auth.perfilAutoritzat('logs-icam')" routerLink="gestio/logs-icam">Logs ICAM</a>
          <div class="dropdown-divider" *ngIf="auth.perfilAutoritzat('diag-no-icam') || auth.perfilAutoritzat('diag-icam')"></div>
          <!-- <a class="dropdown-item" routerLink="gestio/diag-icam" *ngIf="auth.perfilAutoritzat('diag-icam')">Diagnòstics ICAM</a> -->
          <a class="dropdown-item" routerLink="gestio/diag-no-icam" *ngIf="auth.perfilAutoritzat('diag-no-icam')">Diagnòstics no ICAM</a>
        </div>
      </li>
      <li class="nav-item dropdown"
        *ngIf="auth.estaAutenticat() && auth.esAdmin()"
        routerLinkActive="active">
        <a class="nav-link dropdown-toggle" href="#" id="navbarDropdown" role="button" data-toggle="dropdown"
          aria-haspopup="true" aria-expanded="false">
          Administració
        </a>
        <div class="dropdown-menu" aria-labelledby="navbarDropdown">
          <a class="dropdown-item" routerLink="admin/usuaris">Usuaris</a>
          <a class="dropdown-item" routerLink="admin/perfils">Perfils</a>
          <a class="dropdown-item" routerLink="admin/capacitats">Capacitats</a>
        </div>
      </li>
      <li class="nav-item dropdown" routerLinkActive="active">
        <a class="nav-link dropdown-toggle" href="#" id="navbarDropdown" role="button" data-toggle="dropdown"
          aria-haspopup="true" aria-expanded="false">
          Ajuda
          <i class="fa fa-info-circle fa-2"></i>
        </a>
        <div class="dropdown-menu" aria-labelledby="navbarDropdown">
          <a *ngIf="auth.estaAutenticat()" class="dropdown-item" [href]="urlAPI + '/docs/GITIH_guia_usuari.pdf'"
            target="_blank">Guia d'usuari</a>
          <a *ngIf="auth.estaAutenticat() && auth.esAdmin()" class="dropdown-item"
            [href]="urlAPI + '/docs/GITIH_guia_administrador.pdf'" target="_blank">Guia administrador</a>
          <a *ngIf="auth.estaAutenticat() && ajuda" class="dropdown-item" [href]="ajuda" target="_blank">Ajuda</a>
          <a *ngIf="suport" class="dropdown-item" [href]="suport" target="_blank">Suport</a>
          <div *ngIf="auth.estaAutenticat() && auth.esAdmin()" class="dropdown-divider"></div>
          <a class="dropdown-item" *ngIf="auth.estaAutenticat() && auth.esAdmin()" [href]="urlAPI"
            target="_blank">Paràmetres servidor</a>
          <a class="dropdown-item" *ngIf="auth.estaAutenticat() && auth.esAdmin()"
            [href]="urlAPI + '/docs/GITIH_doc_tec.pdf'" target="_blank">Guia tècnica</a>
        </div>
      </li>
      <li class="nav-item" *ngIf="!auth.estaAutenticat()" routerLinkActive="active">
        <a class="nav-link" routerLink="auth/login">Entrar</a>
      </li>
      <li class="nav-item" *ngIf="auth.estaAutenticat()" routerLinkActive="active">
        <a class="nav-link" routerLink="auth/logout">Sortir</a>
      </li>
    </ul>
    <div class="form-inline my-2 my-lg-0 text-white" *ngIf="auth.estaAutenticat()">
      <div>
        {{auth.usuari.id}} (Act: {{auth.usuari.activitats.join()}})
        <br>
        <div class="versio" [ngClass]="{'versioDiferent': !versioIgual}">
          v:{{ versioClient }}
          <span *ngIf="!versioIgual">(servidor: {{ versioServer }})</span>
        </div>
      </div>
      <a class="nav-link" routerLink="auth/logout">
        <i class="fa fa-sign-out fa-2x" style="color: white;" title="Sortir de l'aplicació"></i>
      </a>
    </div>
  </div>
</nav>